import React from 'react';
import styled from 'styled-components';
import { Icon, Text } from '@amzn/storm-ui';
import { spinner } from '@amzn/storm-ui-icons';
import { useTranslation } from 'react-i18next';

const StyledSpan = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  white-space: pre-wrap;
  height: 250px;
`;

const LoadingCardBody = () => {
  const { t: translate } = useTranslation();
  return (
    <StyledSpan>
      <Icon type={spinner} size={'lg'} />
      <Text inline={true} size={'medium'}>
        {` ${translate('sspa_rcm_ad_reports_loading', 'Loading')}`}
      </Text>
    </StyledSpan>
  );
};

export { LoadingCardBody };
